import { render, staticRenderFns } from "./Paginacao.vue?vue&type=template&id=82e54740&scoped=true"
import script from "./Paginacao.vue?vue&type=script&lang=js"
export * from "./Paginacao.vue?vue&type=script&lang=js"
import style0 from "./Paginacao.vue?vue&type=style&index=0&id=82e54740&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "82e54740",
  null
  
)

export default component.exports